module.exports = __webpack_public_path__ + "img/mrtx.916d5751.png";